


// import React, { useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import Cookies from "js-cookie";
// import axios from "axios";
// import { loginApi, registerApi } from "../../Api/api";
// import { setUserCredentials } from "../../Slices/userSlice";
// import { useDispatch } from "react-redux";

// const Auth = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch=useDispatch()
  

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const msisdn = params.get("msisdn");

//     if (msisdn) {
//       // auto-login with msisdn from URL
//       autoLogin(msisdn);
//     } else {
//       // normal token check
//       const token = Cookies.get("token");
//       if (!token) {
//         navigate("/");
//       }
//     }
//   }, [navigate, location.search]);

//   const autoLogin = async (number) => {
//     try {
//       const data = { ani: number, password:number };
//       const res = await axios.post(`${registerApi}`, data);

//       console.log("Auto login response", res.data);
//           dispatch(setUserCredentials(number));

//       Cookies.set("token", res.data.token);
//       // dispatch to redux here if needed
//     } catch (err) {
//       console.error("Auto login failed", err);
//       navigate("/"); // redirect to login on failure
//     }
//   };

//   return <>{children}</>;
// };

// export default Auth;



import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { registerApi } from "../../Api/api";
import { setUserCredentials } from "../../Slices/userSlice";
import { useDispatch } from "react-redux";
import Loading from "../Loading"; // your existing loader

const Auth = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const msisdn = params.get("msisdn");

    if (msisdn) {
      autoLogin(msisdn);
    } else {
      const token = Cookies.get("token");
      if (!token) {
        navigate("/");
      } else {
        setChecking(false);
      }
    }
  }, [location.search]);

  const autoLogin = async (number) => {
    try {
      const data = { ani: number, password: number };
      const res = await axios.post(`${registerApi}`, data);

      Cookies.set("token", res.data.token);
      dispatch(setUserCredentials(number));

      // stay on the current page after auto-login
      setChecking(false);
    } catch (err) {
      console.error("Auto login failed", err);
      navigate("/");
    }
  };

  if (checking) return <Loading />;

  return <>{children}</>;
};

export default Auth;